/* VANA 16.10.2026 – Gold/Silber-Punkte auf Produktkarten: Bild, Preis und Link tauschen ohne Neuladen */
(function () {
  if (window.__vanaMetalSwatch) return;
  window.__vanaMetalSwatch = true;

  var css = '' +
    '.vana-gm{display:flex;align-items:center;justify-content:center;gap:11px;margin:8px 0 2px}' +
    '.text-left .vana-gm,.product__grid__info.text-left .vana-gm{justify-content:flex-start}' +
    '.vana-gm__dot{position:relative;width:14px;height:14px;padding:0;border-radius:50%;border:0;box-shadow:inset 0 0 0 1px rgba(43,39,36,.08);cursor:pointer;-webkit-appearance:none;appearance:none;transition:box-shadow .2s ease}' +
    '.vana-gm__dot::before{content:"";position:absolute;inset:-9px}' +
    '.vana-gm__dot--gold{background:#ead6a6}' +
    '.vana-gm__dot--silber{background:#e1e3e5}' +
    '.vana-gm__dot.is-on{box-shadow:inset 0 0 0 1px rgba(43,39,36,.08),0 0 0 2.5px #fff,0 0 0 3.5px rgba(43,39,36,.32)}' +
    '.vana-gm__dot.is-off{opacity:.5}' +
    '.vana-gm-ov{position:absolute;inset:0;width:100%;height:100%;object-fit:contain;background:#fcfcfc;z-index:3;pointer-events:none;opacity:0;transition:opacity .25s ease}' +
    '.vana-gm-ov.is-in{opacity:1}' +
    '.vana-gm-alt .vana-mobile-card-dots,.vana-gm-alt .vana-po-badge{visibility:hidden}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  function cardOf(el) {
    return el.closest('product-grid-item') || el.closest('.product-grid-item') || el.parentElement;
  }

  function remember(card) {
    if (card.__vanaGm) return card.__vanaGm;
    var orig = card.querySelector('.vana-gm__dot[data-orig]');
    var origUrl = orig ? orig.getAttribute('data-url') : '';
    var links = [];
    card.querySelectorAll('a[href]').forEach(function (a) {
      if (a.closest('.vana-gm')) return;
      var h = a.getAttribute('href') || '';
      if (origUrl && h.split('?')[0] === origUrl) links.push({ a: a, href: h });
    });
    var priceEl = card.querySelector('.product__grid__price .price');
    card.__vanaGm = {
      links: links,
      price: priceEl,
      priceHtml: priceEl ? priceEl.innerHTML : '',
      sale: priceEl ? priceEl.classList.contains('on-sale') : false
    };
    return card.__vanaGm;
  }

  function imageBoxes(card) {
    var boxes = [];
    card.querySelectorAll('[data-grid-images], [data-vana-mobile-card-slider-wrap]').forEach(function (b) {
      boxes.push(b);
    });
    return boxes;
  }

  function select(btn) {
    var card = cardOf(btn);
    if (!card) return;
    var mem = remember(card);
    var isOrig = btn.hasAttribute('data-orig');

    card.querySelectorAll('.vana-gm__dot').forEach(function (d) {
      var on = d === btn;
      d.classList.toggle('is-on', on);
      d.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var url = btn.getAttribute('data-url');
    mem.links.forEach(function (l) {
      l.a.setAttribute('href', isOrig ? l.href : url);
    });

    if (mem.price) {
      if (isOrig) {
        mem.price.innerHTML = mem.priceHtml;
        mem.price.classList.toggle('on-sale', mem.sale);
      } else {
        mem.price.textContent = btn.getAttribute('data-price');
        mem.price.classList.toggle('on-sale', btn.getAttribute('data-sale') === '1');
      }
    }

    card.classList.toggle('vana-gm-alt', !isOrig);
    imageBoxes(card).forEach(function (box) {
      var ov = box.querySelector(':scope > .vana-gm-ov');
      if (isOrig) {
        if (ov) {
          ov.classList.remove('is-in');
          setTimeout(function () { if (ov.parentNode && !ov.classList.contains('is-in')) ov.remove(); }, 260);
        }
        return;
      }
      if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
      if (!ov) {
        ov = document.createElement('img');
        ov.className = 'vana-gm-ov';
        ov.alt = '';
        ov.decoding = 'async';
        ov.sizes = '(min-width: 990px) 25vw, 50vw';
        box.appendChild(ov);
      }
      ov.srcset = btn.getAttribute('data-srcset');
      ov.src = btn.getAttribute('data-img');
      var show = function () { ov.classList.add('is-in'); };
      if (ov.complete && ov.naturalWidth) show(); else ov.onload = show;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.vana-gm__dot');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.classList.contains('is-on')) return;
    select(btn);
  }, true);
})();
